module.exports = __webpack_public_path__ + "static/media/cs.dbe07ce6.png";